export default {
    Alert: (text, title, contextClass) => ({text, title, contextClass})
}